var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "flat": "",
      "rounded": "lg"
    }
  }, 'v-card', Object.assign({}, _vm.$attrs, {
    loading: _vm.loading
  }), false), [_c('v-card-title', {
    staticClass: "d-block py-3"
  }, [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "baseline"
    }
  }, [_c('v-col', {
    staticClass: "pa-2 text-subtitle-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1), _c('v-spacer')], 1), _c('v-divider', {
    staticClass: "content"
  }), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }